import { useState, useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { getImageUrlAdminToken } from "../../utills/ImagesUtilsAdmin";
import { useNavigate } from "react-router-dom";

import {
  Box,
  Container,
  Card,
  CardContent,
  Avatar,
  useTheme,
  Typography,
  CardHeader,
  Paper,
  Button,
  Tabs,
  Tab,
  Divider,
  Chip,
  Pagination,
  Stack,
  Skeleton,
  useMediaQuery,
  Modal,
  Grid,
} from "@mui/material";
import SearchAppBar from "../SearchAppBar";
import Slider from "../Slider";
import ReadMoretext from "../../../utils/ReadMoretext";
import {
  getUserAllPost,
  userAction,
  getUserPostByStatus,
} from "../../services/user_Service";
import { actionOnPost } from "../../services/post_Service";
import PostSkeleton from "../../skelton/PostSkelton";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { ExperienceAccordian } from "../accordian/ExperienceAccordian";
import CustomSnackbar from "../../CustomSnackbar";
import Connections from "./Conections";
import AdminWorkAsPost from "../post/AdminWorkAsPost";
import ProjectCard from "../projects/ProjectCard";
import { generateAdminURL } from "../../utills/HelperUrl";
import Project from "../projects/Project"; // Import Project component
import Work from "../works/Work"; // Import Work component

// Tab Content
const TabContent = ({ children, value, index }) => {
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      sx={{ p: 0, paddingTop: 2 }}
    >
      {value === index && children}
    </Box>
  );
};

const UserDetails = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const ismobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [status, setStatus] = useState(3);
  const [usersposts, setUsersPosts] = useState([null]);
  const [searchResults, setSearchResults] = useState(null);
  const [userProfile, setUserProfile] = useState({});
  const [loading, setLoading] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showConnections, setShowConnections] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [openProfilePicDialog, setOpenProfilePicDialog] = useState(false);
  const [profilePicUrl, setProfilePicUrl] = useState("");
  const [profileName, setProfileName] = useState("");
  const [contentTabValue, setContentTabValue] = useState("posts");


  console.log("userProfile", usersposts);
  // console.log("searchResults", searchResults);

  const displayData = {
    posts: searchResults ? searchResults.data : usersposts?.posts,
  };

  // -------------------handle popup open-------------------
  const handlePopupOpen = (url, name) => {
    setProfilePicUrl(url);
    setProfileName(name);
    setOpenProfilePicDialog(true);
  };

  // -------------------handle popup close-------------------
  const handlePopupClose = () => {
    setOpenProfilePicDialog(false);
    setProfilePicUrl("");
    setProfileName("");
  };

  //--------------------handle page change-------------------
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  // Function to handle search results from SearchAppBar
  const handleSearchResults = (results) => {
    setSearchResults(results);
    if (results && results.pagination) {
      setTotalPages(results.pagination.last_page);
      setPage(results.pagination.current_page);
    }
  };

  //--------------------handle search data change-------------------
  const handleChange = (value) => {
    setLoading(true);
    setStatus(value);
    setPage(1);
  };

  // -----------------------------------fetch user post--------------------------------
  const fetchUserPosts = async () => {
    try {
      const data = await getUserAllPost(userId, page);
      setUsersPosts(data.data);
      setUserProfile(data.data.user);
      const totalPagesFromResponse = data.pagination?.last_page;
      setTotalPages(totalPagesFromResponse);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch posts", error);
      setLoading(false);
    }
  };

  // -----------------------------------fetch user post by status--------------------------------
  const fetchUserPostsByStatus = async () => {
    try {
      const data = await getUserPostByStatus(userId, status, page);
      setUsersPosts(data.data);
      setUserProfile(data.data.user);
      const totalPagesFromResponse = data.data.pagination?.last_page;
      setTotalPages(totalPagesFromResponse);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch posts", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    setSearchResults(null);
    if (status == 3) {
      fetchUserPosts();
    } else {
      fetchUserPostsByStatus();
    }
  }, [status, userId, page]);

  //--------------------handle action for block and unblock user-------------------
  const handleActionUser = async (status, userId) => {
    try {
      const data = await userAction(status, userId);
      setSnackbarMessage(data.message);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      fetchUserPosts();
      fetchUserPostsByStatus();
    } catch (error) {
      console.error("Failed to perform action", error);
      setSnackbarMessage("Failed to perform action");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleActionPost = async (postId, status) => {
    try {
      const data = await actionOnPost(postId, status);
      setSnackbarMessage(data.message || "Post action performed successfully");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      fetchUserPosts();
      fetchUserPostsByStatus();
    } catch (error) {
      console.error("Failed to perform action on post", error);
      setSnackbarMessage(
        error.response?.data?.message || "Failed to perform action on post"
      );
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  //--------------------------handle tabs change-------------------
  const handleTabs = (event, newValue) => {
    setTabValue(newValue);
  };

  // --------------------------handle content tab change-------------------
  const contentTabChange = (event, newValue) => {
    setContentTabValue(newValue);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  // action buttons for post
  const ActionButtons = ({ post }) => (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        flexDirection: ismobile ? "column" : "row",
        width: ismobile ? "100%" : "auto",
        mt: ismobile ? 1 : 0,
      }}
    >
      {post.status === 0 &&
        (!post.project_content || post.project_content.length === 0) &&
        (!post.work_content || post.work_content.length === 0) && (
          <>
            <Button
              variant="outlined"
              color="success"
              disableElevation
              size="small"
              sx={{ textTransform: "none" }}
              onClick={() => handleActionPost(post.id, 2)}
            >
              Approve
            </Button>
            <Button
              variant="outlined"
              color="error"
              disableElevation
              size="small"
              sx={{ textTransform: "none" }}
              onClick={() => handleActionPost(post.id, 1)}
            >
              Block
            </Button>
          </>
        )}

      {post.status === 1 &&
        (!post.project_content || post.project_content.length === 0) &&
        (!post.work_content || post.work_content.length === 0) && (
          <Button
            variant="outlined"
            color="warning"
            disableElevation
            size="small"
            sx={{ textTransform: "none" }}
            onClick={() => handleActionPost(post.id, 0)}
          >
            Unblock
          </Button>
        )}
      {post.status === 2 &&
        (!post.project_content || post.project_content.length === 0) &&
        (!post.work_content || post.work_content.length === 0) && (
          <Button
            variant="outlined"
            color="error"
            disableElevation
            size="small"
            sx={{ textTransform: "none" }}
            onClick={() => handleActionPost(post.id, 1)}
          >
            Block
          </Button>
        )}

      {post.work_content.length > 0 && (
        <Button
          variant="outlined"
          color="primary"
          disableElevation
          size="small"
          sx={{ textTransform: "none" }}
          onClick={() =>
            navigate(
              generateAdminURL(
                "works",
                post.work_content[0].work_listing_id,
                post.work_content[0].title
              )
            )
          }
        >
          View Details
        </Button>
      )}
    </Box>
  );

  const renderUserContent = (post) => {
    if (post.work_content && post.work_content.length > 0) {
      return (
        <Grid size={{ xs: 12 }} sx={{ width: "100%" }}>
          <AdminWorkAsPost workContent={post.work_content[0]} />
        </Grid>
      );
    }

    if (post.project_content && post.project_content.length > 0) {
      console.log("project_content", post.project_content);
      return (
        <Grid size={{ xs: 12 }} sx={{ width: "100%" }}>
          <ProjectCard projectContent={post.project_content[0]} type="Allpost" />
        </Grid>
      );
    }

    return (
      <Grid
        container
        spacing={2}
        sx={{
          px: 2,
          pb: 1,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {post.text_content && (
          <Grid size={{ xs: 12 }} sx={{ maxWidth: "400px", textAlign: "left" }}>
            <ReadMoretext text={post.text_content} maxLength={600} />
          </Grid>
        )}
        {post.post_content?.length > 0 && (
          <Grid
            size={{ xs: 12 }}
            sx={{
              maxWidth: "400px",
              textAlign: post.text_content ? "right" : "center",
            }}
          >
            <Slider
              mediaContent={post.post_content.map((content) =>
                getImageUrlAdminToken(content.media_content_blob)
              )}
            />
          </Grid>
        )}
      </Grid>
    );
  };

  return (
    <Container
      maxWidth="xl"
      sx={{ py: ismobile ? 2 : 4, px: ismobile ? 1 : 3 }}
    >
      <Grid container spacing={1}>
        {/* Left Side */}
        <Grid size={{ xs: 12, md: 3 }}>
          <Card elevation={0} sx={{ position: "sticky", top: 100 }}>
            <CardContent sx={{ position: "relative" }}>
              {/* Background Overlay */}
              <Box
                sx={{
                  padding: 6,
                  background:
                    "linear-gradient(0deg, rgba(255, 191, 191, 0.7), rgba(82, 82, 82, 0.7))",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                }}
              />

              <Stack spacing={2} alignItems="center" mt={3} pb={2}>
                {/* Avatar */}
                <Avatar
                  sx={{ width: 70, height: 70, cursor: "pointer" }}
                  alt={userProfile.name}
                  src={
                    loading
                      ? null
                      : getImageUrlAdminToken(userProfile.thumbnail_pic)
                  }
                  onClick={() =>
                    handlePopupOpen(
                      getImageUrlAdminToken(userProfile.thumbnail_pic),
                      userProfile.name
                    )
                  }
                >
                  {loading ? (
                    <Skeleton
                      animation="wave"
                      variant="circular"
                      width={100}
                      height={100}
                    />
                  ) : userProfile.name ? (
                    userProfile.name.charAt(0).toUpperCase()
                  ) : (
                    ""
                  )}
                </Avatar>

                {/* User Information */}
                <Box textAlign="center">
                  <Typography variant="h6" color="text.primary" sx={{ fontSize: "1rem" }}>
                    {loading ? (
                      <Skeleton
                        animation="wave"
                        width={100}
                        sx={{ display: "inline-block" }}
                      />
                    ) : (
                      userProfile.name || "Name"
                    )}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {loading ? (
                      <Skeleton
                        animation="wave"
                        width={100}
                        sx={{ display: "inline-block" }}
                      />
                    ) : (
                      userProfile.bio
                    )}
                  </Typography>
                  <Typography variant="body2">
                    {loading ? (
                      <Skeleton
                        animation="wave"
                        width={250}
                        sx={{ display: "inline-block" }}
                      />
                    ) : (
                      <>
                        {userProfile.username || "Username"} - joined on{" "}
                        {new Date(userProfile.created_at).toLocaleDateString("en-GB", {
                          day: "numeric",
                          month: "short",
                          year: "numeric",
                        })}
                      </>
                    )}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", gap: 1 }}>
                  {loading ? (
                    <>
                      <Skeleton
                        variant="rectangular"
                        width={150}
                        height={36}
                        sx={{ display: "inline-block" }}
                      />
                      <Skeleton
                        variant="rectangular"
                        width={100}
                        height={36}
                        sx={{ display: "inline-block" }}
                      />
                    </>
                  ) : (
                    <>
                      <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => setShowConnections(true)}
                        disableElevation
                        sx={{ textTransform: "none" }}
                      >
                        {userProfile?.connections_count} Connections
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        disableElevation
                        sx={{ textTransform: "none" }}
                        onClick={() =>
                          handleActionUser(
                            userProfile.id,
                            userProfile.status === 1 ? 3 : 1
                          )
                        }
                      >
                        {userProfile?.status === 1 ? "Block" : "Unblock"}
                      </Button>
                    </>
                  )}
                </Box>
              </Stack>
              <Stack>
                {loading ? (
                  <Skeleton
                    animation="wave"
                    height={48}
                    width="100%"
                    sx={{ mb: 1 }}
                  />
                ) : (
                  <Tabs value={tabValue} onChange={handleTabs} centered>
                    <Tab
                      label="Interests"
                      sx={{ fontSize: "0.90rem", textTransform: "none" }}
                    />
                    <Tab
                      label="Skills"
                      sx={{ fontSize: "0.90rem", textTransform: "none" }}
                    />
                    <Tab
                      label="Experience"
                      sx={{ fontSize: "0.90rem", textTransform: "none" }}
                    />
                  </Tabs>
                )}
                <Divider />
                {/* Tab Contents */}
                <TabContent value={tabValue} index={0}>
                  <Box sx={{ maxHeight: "400px", overflowY: "auto", p: 1 }}>
                    {userProfile?.interests &&
                      userProfile.interests.length > 0 ? (
                      <>
                        {userProfile.interests
                          .slice(0, showAll ? userProfile.interests.length : 5)
                          .map((interest, index) => (
                            <Chip
                              clickable={false}
                              onClick={() => { }}
                              key={index}
                              label={interest}
                              sx={{ m: 0.5 }}
                              variant="outlined"
                            />
                          ))}
                        {userProfile.interests.length > 5 && (
                          <Button
                            size="small"
                            variant="text"
                            sx={{ textTransform: "none", mx: 2 }}
                            onClick={() => setShowAll(!showAll)}
                          >
                            {showAll ? "Show Less..." : "Show More..."}
                          </Button>
                        )}
                      </>
                    ) : (
                      <Typography>No interests available</Typography>
                    )}
                  </Box>
                </TabContent>

                <TabContent value={tabValue} index={1}>
                  <Box sx={{ maxHeight: "300px", overflowY: "auto", p: 1 }}>
                    {userProfile?.skills && userProfile.skills.length > 0 ? (
                      userProfile.skills.map((skill, index) => (
                        <Chip
                          clickable={false}
                          onClick={() => { }}
                          key={index}
                          label={skill}
                          sx={{ m: 0.5 }}
                          variant="outlined"
                        />
                      ))
                    ) : (
                      <Typography>No skills available</Typography>
                    )}
                  </Box>
                </TabContent>

                <TabContent value={tabValue} index={2}>
                  <Box
                    sx={{
                      maxHeight: "300px",
                      overflowY: "auto",
                      p: 1,
                      mb: 3,
                    }}
                  >
                    {userProfile.experiences && userProfile.experiences.length > 0 ? (
                      <ExperienceAccordian experience={userProfile.experiences} />
                    ) : (
                      <Typography>No experience available</Typography>
                    )}
                    
                  </Box>
                </TabContent>
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        {/* Main Content */}
        <Grid size={{ xs: 12, md: 9 }}>
          {showConnections ? (
            <Connections
              userId={userId}
              onBack={() => setShowConnections(false)}
            />
          ) : (
            <>


              {/* Tabs for Posts, Projects, Jobs */}
              <Paper elevation={0} sx={{ mb: 2 }}>
                <Tabs
                  value={contentTabValue}
                  onChange={contentTabChange}
                  variant="fullWidth"
                  sx={{ borderBottom: 1, borderColor: "divider" }}
                >
                  {/* <Tab
                    value="profile"
                    label="Profile"
                    sx={{ fontSize: "0.90rem", textTransform: "none" }}
                  /> */}
                  <Tab
                    value="posts"
                    label="Posts"
                    sx={{ fontSize: "0.90rem", textTransform: "none" }}
                  />
                  <Tab
                    value="projects"
                    label="Projects"
                    sx={{ fontSize: "0.90rem", textTransform: "none" }}
                  />
                  <Tab
                    value="jobs"
                    label="Jobs"
                    sx={{ fontSize: "0.90rem", textTransform: "none" }}
                  />
                </Tabs>
              </Paper>
              {/* Show SearchAppBar only for Posts tab */}
              {contentTabValue === "posts" && (
                <Paper
                  elevation={0}
                  sx={{
                    position: "sticky",
                    top: ismobile ? 56 : 60,
                    mb: ismobile ? 1 : 2,
                    zIndex: 10,
                  }}
                >
                  <SearchAppBar
                    status={status}
                    handleChange={handleChange}
                    SearchData={handleSearchResults}
                  />
                </Paper>
              )}

              {/* Tab Content Rendering */}
              {contentTabValue === "posts" && (
                <>
                  {displayData?.posts?.length === 0 && !loading && (
                    <Box
                      sx={{
                        textAlign: "center",
                        mt: 5,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <CameraAltIcon
                        sx={{ fontSize: ismobile ? 60 : 100, color: "action" }}
                      />
                      <Typography
                        variant={ismobile ? "h5" : "h4"}
                        color="textSecondary"
                        align="center"
                      >
                        No posts found.
                      </Typography>
                    </Box>
                  )}

                  {/* Map the usersPosts.data */}
                  {loading ? (
                    <PostSkeleton count={ismobile ? 3 : 5} />
                  ) : (
                    displayData?.posts?.map((post) => (
                      <Paper
                        elevation={0}
                        key={post.id}
                        sx={{ mb: ismobile ? 2 : 1, overflow: "hidden" }}
                      >
                        <Card elevation={0}>
                          <CardHeader
                            sx={{
                              p: ismobile ? 1.5 : 2,
                              "& .MuiCardHeader-content": {
                                overflow: "hidden",
                              },
                            }}
                            avatar={
                              <Avatar
                                src={
                                  userProfile.thumbnail_pic
                                    ? getImageUrlAdminToken(
                                      userProfile.thumbnail_pic
                                    )
                                    : "https://source.unsplash.com/random"
                                }
                                alt={userProfile.name}
                                sx={{
                                  width: ismobile ? 32 : 40,
                                  height: ismobile ? 32 : 40,
                                  cursor: "pointer",
                                }}
                              >
                                {post.name
                                  ? post.name.charAt(0).toUpperCase()
                                  : ""}
                              </Avatar>
                            }
                            title={userProfile.name}
                            subheader={
                              <Typography
                                variant={ismobile ? "caption" : "body2"}
                                color="text.secondary"
                              >
                                {new Date(post.created_at).toLocaleDateString("en-GB", {
                                  day: "numeric",
                                  month: "long",
                                  year: "numeric",
                                })}
                              </Typography>
                            }

                            action={!ismobile && <ActionButtons post={post} />}
                          />
                          <Grid
                            container
                            spacing={2}
                            sx={{
                              px: 2,
                              pb: 1,
                              justifyContent: post.text_content
                                ? "space-between"
                                : "center",
                              alignItems: "center",
                            }}
                          >
                            {renderUserContent(post)}
                          </Grid>
                          {ismobile && (
                            <Box sx={{ p: 1.5, pt: 0 }}>
                              <ActionButtons post={post} />
                            </Box>
                          )}
                        </Card>
                      </Paper>
                    ))
                  )}

                  {/* Pagination only for Posts tab */}
                  <Stack
                    spacing={2}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    {totalPages > 1 && (
                      <Pagination
                        count={totalPages}
                        page={page}
                        color="primary"
                        onChange={handlePageChange}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          mt: 2,
                        }}
                      />
                    )}
                  </Stack>
                </>
              )}

              {contentTabValue === "projects" && <Project userTabsValue={contentTabValue} userId={userId} />}

              {contentTabValue === "jobs" && <Work userTabsValue={contentTabValue} userId={userId} />}
            </>
          )}
        </Grid>
      </Grid>
      <CustomSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
      <Modal open={openProfilePicDialog} onClose={handlePopupClose}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            borderRadius: "50%",
            outline: "none",
            width: { xs: 280, sm: 320, md: 400 },
            height: { xs: 280, sm: 320, md: 400 },
          }}
        >
          <Avatar
            src={profilePicUrl}
            alt={profileName}
            sx={{
              width: "100%",
              height: "100%",
            }}
          />
        </Box>
      </Modal>
    </Container>
  );
};

export default UserDetails;